import Api from './Api'
import { checkBfaResponse } from './BfaResponse'

export { checkBfaResponse } from './BfaResponse'

const BfaApi = Object.fromEntries(
  ['get', 'post', 'delete'].map((method) => [
    method,
    (...args) => Api[method](...args).then(checkBfaResponse),
  ]),
)
export default BfaApi
